// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { ConfigurationService } from '../../../services/configuration-service';
import { CigentUserAgreementURL, LenovoUserAgreementURL, Partners } from '../../../types/partners';

export interface IDownloadVersion {
    name: string;
    url: string;
    msi_url?: string;
    version: string;
}

export interface IVersionData {
  consoleVersion: string;
  latestCigentVersion: string;
  restApiVersion: string;
  pba_brand: number;
  pba_drive_mask: string;
  pbaVersions: IDownloadVersion[];
  msiVersion: string;
  winCliVersions: IDownloadVersion[];
  ubuntuCliVersions: IDownloadVersion[];
  rhelCliVersions: IDownloadVersion[];
  winFdeVersions: IDownloadVersion[];
  ubuntuFdeVersions: IDownloadVersion[];
  rhelFdeVersions: IDownloadVersion[];
  winAgentVersions: IDownloadVersion[];
  ubuntuAgentVersions: IDownloadVersion[];
  rhelAgentVersions: IDownloadVersion[];
}

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false
})

export class NewsComponent {
  title: string;
  cigentPartner = Partners.Cigent;
  doqubizPartner = Partners.Doqubiz;
  digistorPartner = Partners.Digistor;
  kanguruPartner = Partners.Kanguru;
  lenovoPartner = Partners.Lenovo;
  partnerId: Partners = Partners.Cigent;
  thisYear = new Date().getFullYear();
  LenovoUserAgreementURL = LenovoUserAgreementURL;
  CigentUserAgreementURL = CigentUserAgreementURL;

  fHeader: string;
  fD3E: string;
  fHere: string;
  fView: string;
  fGot: string;
  constructor(public dialogRef: MatDialogRef<NewsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IVersionData,
              private translate: TranslateService,
              private configuration: ConfigurationService) {
    this.translate.get(['NEWS_HEADER', 'NEWS_D3E', 'NEWS_HERE', 'NEWS_VIEW', 'NEWS_GOT']).subscribe(vals => {
      this.fHeader = vals['NEWS_HEADER'];
      this.fD3E = vals['NEWS_D3E'];
      this.fHere = vals['NEWS_HERE'];
      this.fView = vals['NEWS_VIEW'];
      this.fGot = vals['NEWS_GOT'];
    });
    this.partnerId = this.configuration.partnerId ?? Partners.Cigent;
  }

  cancel() {
    this.dialogRef.close();
  }

}
